import {announce} from '@github-ui/aria-live'
import {useReopenPullRequestMutation} from '@github-ui/mergebox/use-reopen-pull-request-mutation'
import {GitPullRequestClosedIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useInvalidatePrState} from '../../data/use-invalidate-pr-state'
import {FailureDialog} from '../../sidebar-actions/FailureDialog'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {PullRequestState} from '../../../../types'

export function ReopenPullRequest({canReopen, variant}: {canReopen: boolean; variant?: 'default' | 'embedded'}) {
  const invalidatePrState = useInvalidatePrState()
  const reopenMutation = useReopenPullRequestMutation({
    onSuccess: () => {
      announce('Pull request reopened')
      invalidatePrState(PullRequestState.Open)
    },
  })

  return (
    <>
      <ForYouItem
        leadingVisual={<ForYouLeadingIcon icon={GitPullRequestClosedIcon} variant="default" />}
        title="Reopen pull request"
        itemName="reopen-pull-request"
        variant={variant}
        description={canReopen ? 'This pull request was closed. Reopen it if you still need it.' : 'Nothing to do.'}
        actionSlot={
          canReopen ? (
            <Button
              size="small"
              loading={reopenMutation.isPending}
              loadingAnnouncement="Reopening pull request"
              onClick={() => reopenMutation.mutate()}
            >
              Reopen pull request
            </Button>
          ) : null
        }
      />
      {reopenMutation.isError && (
        <FailureDialog
          title="Failed to reopen pull request"
          message="An error occurred while reopening this pull request. Please try again."
          details={reopenMutation.error.message}
          onRetry={() => reopenMutation.mutate()}
          onDismiss={() => reopenMutation.reset()}
        />
      )}
    </>
  )
}
